export const colorCells = [
  { id: 'MAGENTA', label: 'Magenta', color: '#c658ca' },
  { id: 'CYAN', label: 'Cyan', color: '#11e9e9' },
  { id: 'GREEN', label: 'Green', color: '#29a849' },
  { id: 'BLUE', label: 'Blue', color: '#0078d4' },
  { id: 'RED', label: 'Red', color: '#d14249' },
  { id: 'YELLOW', label: 'Yellow', color: '#ffd000' },
];
